// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__5dEW6","imageUploader":"EGiftCard_imageUploader__3Hsrx"};